import React from "react";
import { motion } from "framer-motion";
import {
  BookOpen, UserRound, Users2, GraduationCap, FileCheck2, Languages,
  Globe2, Building2, HeartHandshake, Brain, Sprout, MessagesSquare,
} from "lucide-react";

const services = [
  { icon: BookOpen, title: "Salas de Estudo", desc: "Espaço calmo, organizado e supervisionado para estudar com foco e método." },
  { icon: UserRound, title: "Explicações Individuais", desc: "Atenção 100% dedicada às necessidades e ritmo de cada aluno." },
  { icon: Users2, title: "Explicações em Grupo", desc: "Pequenos grupos para aprendizagem colaborativa e motivadora." },
  { icon: GraduationCap, title: "Apoio ao Estudo", desc: "Método, organização e estratégias para resultados consistentes." },
  { icon: FileCheck2, title: "Preparação Exames Nacionais", desc: "Treino intensivo e simulações orientadas para o sucesso." },
  { icon: Languages, title: "Inglês Cambridge", desc: "Desde A1 até C2 — domínio real da língua, com confiança." },
  { icon: Globe2, title: "Exames Cambridge", desc: "Preparação certificada para KET, PET, FCE, CAE e CPE." },
  { icon: Building2, title: "Apoio Universitário", desc: "Suporte em disciplinas técnicas e científicas do ensino superior." },
  { icon: HeartHandshake, title: "Coaching em PNL", desc: "Sessões de coaching em Programação Neurolinguística para foco, confiança e gestão emocional." },
  { icon: Brain, title: "Gestão Emocional", desc: "Espaço seguro para compreender e regular emoções." },
  { icon: Sprout, title: "Desenvolvimento Pessoal", desc: "Autoestima, autonomia, disciplina e crescimento humano." },
  { icon: MessagesSquare, title: "PNL & Comunicação", desc: "Programação Neurolinguística aplicada ao desempenho e à expressão." },
];

export const Services = () => {
  return (
    <section id="servicos" data-testid="services-section" className="section bg-stone-50">
      <div className="container-tight">
        <div className="max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-bordeaux-700 mb-4">Os Nossos Serviços</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-stone-900 leading-tight">
            Tudo o que o aluno precisa, <span className="italic text-bordeaux-700">num só lugar.</span>
          </h2>
          <p className="mt-5 text-stone-600 max-w-2xl leading-relaxed">
            Do apoio ao estudo à preparação Cambridge, do wellbeing à PNL — uma oferta integrada que cuida do
            desempenho académico e do equilíbrio pessoal.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              data-testid={`service-card-${i}`}
              className="group relative p-7 rounded-2xl bg-white border border-stone-100 hover:border-bordeaux-200 transition-all hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(28,25,23,0.08)]"
            >
              <div className="h-12 w-12 rounded-xl bg-navy-50 text-navy-700 flex items-center justify-center group-hover:bg-bordeaux-700 group-hover:text-white transition-colors">
                <s.icon size={22} strokeWidth={1.5} />
              </div>
              <div className="mt-5 font-display text-xl text-stone-900">{s.title}</div>
              <div className="mt-2 text-sm text-stone-600 leading-relaxed">{s.desc}</div>
              <div className="absolute bottom-7 right-7 opacity-0 group-hover:opacity-100 transition-opacity text-bordeaux-700 text-sm font-semibold">→</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
